module.exports = __webpack_public_path__ + "static/media/excluding.8301f884.png";